import { INSTRUMENTS } from "./constants.js";

let activeNotes = new Map(); // Track active notes and their gain nodes
let cleanupTimeouts = new Map(); // Track cleanup timeouts for each note

function getBasePath() {
  // Get the current path depth
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  return pathParts.length > 1 ? '../' : './';
}

export function loadInstrument(audioContext, player, instrumentIndex) {
  document.getElementById("loading").style.display = "block";
  const instrument = INSTRUMENTS[instrumentIndex];
  console.log(`🎹 Loading ${instrument.name}...`);

  return new Promise((resolve) => {
    const basePath = getBasePath();
    const instrumentPath = basePath + instrument.url;
    player.loader.startLoad(audioContext, instrumentPath, instrument.variable);
    player.loader.waitLoad(() => {
      const loadedInstrument = window[instrument.variable];
      document.getElementById("loading").style.display = "none";
      console.log(`✅ ${instrument.name} Loaded!`);
      resolve(loadedInstrument);
    });
  });
}

export function playNote(
  audioContext,
  player,
  pianoInstrument,
  note,
  velocity = 0.75,
) {
  // Clear any existing cleanup timeout for this note
  const existingTimeout = cleanupTimeouts.get(note);
  if (existingTimeout) {
    clearTimeout(existingTimeout);
    cleanupTimeouts.delete(note);
  }

  // Use the current instrument from the window object if available
  const currentInstrument = window.currentInstrument || pianoInstrument;
  if (!currentInstrument) return;

  // Get the duration value from the slider (default to 2.0 if not found)
  const durationSlider = document.getElementById('noteDurationSlider');
  const duration = durationSlider ? parseFloat(durationSlider.value) : 2.0;

  // Create a gain node for volume control
  const gainNode = audioContext.createGain();
  gainNode.connect(audioContext.destination);
  gainNode.gain.value = velocity;

  // Store the gain node and start time
  activeNotes.set(note, {
    gainNode,
    startTime: audioContext.currentTime,
  });

  player.queueWaveTable(
    audioContext,
    gainNode,
    currentInstrument,
    audioContext.currentTime,
    note,
    duration,
    velocity,
  );
}

export function stopNote(audioContext, note) {
  const activeNote = activeNotes.get(note);
  if (activeNote) {
    const { gainNode, startTime } = activeNote;
    const releaseTime = 0.15; // Release time in seconds
    const now = audioContext.currentTime;
    const noteLength = now - startTime;

    // Only apply release if the note has played for at least a short duration
    if (noteLength > 0.05) {
      gainNode.gain.setValueAtTime(gainNode.gain.value, now);
      gainNode.gain.linearRampToValueAtTime(0, now + releaseTime);

      // Store the cleanup timeout
      const timeoutId = setTimeout(() => {
        gainNode.disconnect();
        activeNotes.delete(note);
        cleanupTimeouts.delete(note);
      }, releaseTime * 1000);
      cleanupTimeouts.set(note, timeoutId);
    } else {
      // For very short notes, fade out more quickly
      gainNode.gain.setValueAtTime(gainNode.gain.value, now);
      gainNode.gain.linearRampToValueAtTime(0, now + 0.02);

      const timeoutId = setTimeout(() => {
        gainNode.disconnect();
        activeNotes.delete(note);
        cleanupTimeouts.delete(note);
      }, 20);
      cleanupTimeouts.set(note, timeoutId);
    }
  }
}

document.getElementById('noteDurationSlider').addEventListener('input', (e) => {
  document.getElementById('durationValue').textContent = `${e.target.value}s`;
});

document.getElementById('continuousSpeedSlider').addEventListener('input', (e) => {
  document.getElementById('speedValue').textContent = `${e.target.value}s`;
});
